<template>
    <div class="mt-4">
        <h5 class="font-weight-bolder">Payment Gateway (Juspay)</h5>
        <p class="text-muted">
            Used to collect fee payments online. Once saved, secret values are never shown again here -
            leave a secret field blank to keep its current value unchanged.
        </p>

        <span v-if="loading" class="text-warning">Loading settings...</span>

        <div v-else>
            <b-form-group>
                <b-form-checkbox v-model="form.is_active" inline>
                    Enabled
                </b-form-checkbox>
            </b-form-group>

            <b-form-group label="API Key">
                <b-form-input v-model.trim="form.api_key" type="password"
                    :placeholder="status.has_api_key ? 'Already set - leave blank to keep it' : 'Enter API key'" />
            </b-form-group>

            <b-form-group label="Merchant ID">
                <b-form-input v-model.trim="form.merchant_id" type="password"
                    :placeholder="status.has_merchant_id ? 'Already set - leave blank to keep it' : 'Enter merchant ID'" />
            </b-form-group>

            <b-form-group label="Base URL">
                <b-form-input v-model.trim="form.base_url" placeholder="e.g. https://smartgatewayuat.hdfcbank.com" />
            </b-form-group>

            <b-form-group label="Payment Page Client ID">
                <b-form-input v-model.trim="form.payment_page_client_id" />
            </b-form-group>

            <hr>
            <h6 class="font-weight-bold">Webhook</h6>
            <p class="text-muted small">
                Configure these same values in the gateway's own merchant dashboard, under webhook Basic Auth.
            </p>

            <b-form-group label="Webhook Username">
                <b-form-input v-model.trim="form.webhook_username" />
            </b-form-group>

            <b-form-group label="Webhook Password">
                <b-form-input v-model.trim="form.webhook_password" type="password"
                    :placeholder="status.has_webhook_password ? 'Already set - leave blank to keep it' : 'Enter webhook password'" />
            </b-form-group>

            <b-button variant="primary" :disabled="saving" @click="save">
                Save
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            saving: false,
            status: {
                configured: false,
                has_api_key: false,
                has_merchant_id: false,
                has_webhook_password: false,
            },
            form: {
                is_active: true,
                api_key: '',
                merchant_id: '',
                base_url: '',
                payment_page_client_id: '',
                webhook_username: '',
                webhook_password: '',
            },
        };
    },

    created() {
        this.loadSettings();
    },

    methods: {
        async loadSettings() {
            this.loading = true;
            try {
                const url = `${this.$store.getters.getAPIKey.mainAPI}/institution/paymentgateway`;
                const response = await this.$axios.get(url);
                this.status = response.data;
                this.form.is_active = response.data.is_active;
                this.form.base_url = response.data.base_url || '';
                this.form.payment_page_client_id = response.data.payment_page_client_id || '';
                this.form.webhook_username = response.data.webhook_username || '';
            } catch (error) {
                this.$toast.error('Failed to load payment gateway settings', {
                    position: 'top',
                    duration: 4000,
                });
            } finally {
                this.loading = false;
            }
        },

        async save() {
            this.saving = true;
            try {
                const url = `${this.$store.getters.getAPIKey.mainAPI}/institution/paymentgateway`;
                await this.$axios.post(url, this.form);

                this.$toast.success('Payment gateway settings saved successfully.', {
                    position: 'top',
                    duration: 4000,
                });

                // Secrets are write-only - clear the inputs and refresh the
                // has_* flags rather than leaving what was just typed on screen.
                this.form.api_key = '';
                this.form.merchant_id = '';
                this.form.webhook_password = '';
                await this.loadSettings();
            } catch (error) {
                this.$toast.error(error.response?.data?.message || 'Failed to save payment gateway settings.', {
                    position: 'top',
                    duration: 4000,
                });
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>
